import React from "react";
import { Text, StyleSheet, TextProps } from "react-native";

const CustomText: React.FC<TextProps> = ({ style, children, ...props }) => {
  return (
    <Text style={[style, styles.defaultText]} {...props}>
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  defaultText: {
    fontFamily: "Urbanist_400Regular", // Ensure this font is loaded in your app
    userSelect: "none", // Prevent text selection
  },
});

export default CustomText;
